import { getIsAdfenixToken, jwtPayload } from "atoms/auth";
import { useRecoilState, useRecoilValue } from "recoil";
import { AWSCognitoUser } from "types/AWSCognito";
import { JwtPayload } from "types/JWT";
import { Auth } from "aws-amplify";
import { deleteAdfenixToken } from "utils/authHelpers";

export const useCognito = () => {
  const [payload, setPayload] = useRecoilState(jwtPayload);
  const isAdfenixToken = useRecoilValue(getIsAdfenixToken);

  const persistCognitoPayload = (cognitoUser: AWSCognitoUser) => {
    if (cognitoUser && (!payload || isAdfenixToken)) {
      const user = cognitoUser?.getSignInUserSession();
      const idToken = user?.getIdToken();
      const jwtPayload = idToken?.decodePayload() as JwtPayload | undefined;
      deleteAdfenixToken();
      setPayload(jwtPayload);
    }
  };

  const forceRefreshToken = async () => {
    const cognitoUser: AWSCognitoUser = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    if (cognitoUser) {
      const refreshToken = cognitoUser
        .getSignInUserSession()
        ?.getRefreshToken();

      persistCognitoPayload(cognitoUser);
      if (refreshToken) {
        cognitoUser.refreshSession(refreshToken, () => {});
      }
    }
  };
  return { persistCognitoPayload, forceRefreshToken };
};
